export enum LocationType {
	Dc = 'Dc',
	Store = 'Store',
	Supplier = 'Supplier',
}
